export const SUCCESS_STATUS = 'ok';
export const ERROR_STATUS = 'error';